import gql from 'graphql-tag';

import { USER_TYPE } from '../../user/graphql/UserType.gql';

const EMPLOYEES_TYPE = gql`
  fragment EmployeesType on EmployeeType {
    id
    user {
      id
      username
    }
  }
`;

export const EMPLOYEE_TYPE = gql`
  ${USER_TYPE}, ${EMPLOYEES_TYPE}
  fragment EmployeeType on EmployeeType {
    id
    createdAt
    memberSet(last: 1, role_Isnull: false) {
          edges {
          node {
              id
              role {
              id
              title
              }
          }
          }
      }
    organizationSet {
      edges {
        node {
          id
          name
          email
          poc {
            edges{
              node{
                id
                user{
                  id
                }
              }
            }
          }
          ceo {
            id
            user {
              id
            }
          }
          allowComparison
        }
      }
    }
    verticalMembersEmployee {
      edges {
        node {
          id
          heads {
            edges {
              node {
                id
                user {
                  id
                }
              }
            }
          }
        }
      }
    }
    teamManagerEmployee {
      totalCount
      edges {
        node {
          id
          name
          managers {
            edges {
              node {
                id
                user {
                  id
                }
              }
            }
          }
          employees {
            edges {
              node {
                ...EmployeesType
              }
            }
          }
        }
      }
    }
    teamMembersEmployee {
      edges {
        node {
          id
          managers {
            edges {
              node {
                id
                user {
                  id
                }
              }
            }
          }
          employees {
            edges {
              node {
                ...EmployeesType
              }
            }
          }
        }
      }
    }
    orgPocEmployee{
      totalCount
      edges{
        node{
          id
          email
          name
        }
      }
    }
    orgCeoEmployee{
      totalCount
    }
    orgAmEmployee{
      totalCount
      edges{
        node{
          id
          email
          name
        }
      }
    }
    defaultOrganization{
      id
      defaultOrganization{
        id
        name
      }
    }
    verticalHeadEmployee{
      totalCount
      edges{
        node {
          id
          name
        }
      }
    }
    user {
      ...UserType
    }
    createdBy {
      ...UserType
    }
    updatedBy {
      ...UserType
    }
  }
`;
